import { EyeOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import { useCallback, useState } from 'react';
import './AccountsSearchSelect.scss';
import {apiAccountsList} from '../../../api/accounts';

const { Option } = Select;

const AccountsSearchSelect = ({
    value,
    onChange,
    placeholder = "Selecione uma opção",
    hasError = false,
    disabled = false,
    notFoundText = "Nenhum resultado encontrado",
    showEyeIcon = false,
    allowClear = false,
    eyeIconUrl = null,
    errorMessage = null,
    ...props
}) => {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchOptions = useCallback(async (searchValue = '') => {
        setLoading(true);
        try {
            const response = await apiAccountsList({ search: searchValue, page_size: 100 });
            
            setOptions(response.results.map(item => ({
                value: item.id,
                label: item.display_name
            })));
        } catch (error) {
            console.error("Erro ao buscar dados:", error);
            setOptions([]);
        } finally {
            setLoading(false);
        }
    }, []);

    const handleDropdownVisibleChange = async (visible) => {
        if (visible) {
            await fetchOptions('');
        }
    };

    //   useEffect(() => {
    //     // Handle search text changes with debounce only after initial mount
    //     if (mountedRef.current && searchText.trim() !== "") {
    //       const delayDebounceFn = setTimeout(() => {
    //         fetchData({
    //           page: pagination.current,
    //           search: searchText,
    //           status: statusFilter.length > 0 ? statusFilter : undefined,
    //           payment_type: paymentTypeFilter || undefined,
    //           created_at_gte: dateRange[0]?.format("YYYY-MM-DD") || undefined,
    //           created_at_lte: dateRange[1]?.format("YYYY-MM-DD") || undefined,
    //         });
    //       }, 1500);
    
    //       return () => clearTimeout(delayDebounceFn);
    //     }
    //   }, [searchText, pagination.current, statusFilter, paymentTypeFilter, dateRange]);

    const handleSearch = async (searchValue) => {
        await fetchOptions(searchValue);
    };

    const getDisplayName = (value) => (value && value.display_name) || placeholder;

    const handleEyeIconClick = () => {
        if (eyeIconUrl && value) {
            window.open(eyeIconUrl.replace('{id}', value), "_blank");
        }
    };    
    
    const onSelectChange = (selectedValue) => {
        const selectedOption = options.find(option => option.value === selectedValue);
        if (selectedOption) {
            onChange({
                id: selectedOption.value,
                display_name: selectedOption.label
            });
        } else {
            onChange(null);
        }
    }

    return (
        <div className="accounts-search-select">
            <div className='input-container'>
                <Select
                    showSearch
                    value={getDisplayName(value)}
                    className={hasError ? 'error-select' : ''}
                    placeholder={placeholder}
                    onChange={onSelectChange}
                    onSearch={handleSearch}
                    onDropdownVisibleChange={handleDropdownVisibleChange}
                    notFoundContent={loading ? "Carregando..." : notFoundText}
                    style={{ width: '100%' }}
                    filterOption={false}
                    loading={loading}
                    disabled={disabled}
                    allowClear={allowClear}
                    {...props}
                >
                    {options.map(option => (
                        <Option key={option.value} value={option.value}>
                            {option.label}
                        </Option>
                    ))}
                </Select>
                {showEyeIcon && value && eyeIconUrl && (
                    <EyeOutlined
                        onClick={handleEyeIconClick}
                        className='eye-icon'
                    />
                )}
            </div>
            {hasError && errorMessage && (
                <div className="error-text">{errorMessage}</div>
            )}
        </div>
    );
};

export default AccountsSearchSelect;
